import http from '../../utils/Http/Http'
import { UserDataPayload } from './types'

export const updateUser = async (payload: Partial<UserDataPayload>) => {
	return http({
		url: '/user',
		method: 'put',
		data: payload,
	})
}
